import { FallbackProps } from 'react-error-boundary'

import GlobalErrorContent from 'common/components/error/GlobalErrorContent'
import { ReactComponent as PhraseePrimaryLogo } from 'common/icons/phraseeLogo/primary.svg'
import AuthFooter from 'features/auth/components/Footer'

const Error: React.FC<FallbackProps> = ({ resetErrorBoundary }) => {
  return (
    <div className="relative min-h-screen flex flex-col justify-center">
      <div className="flex justify-center">
        <img
          className="absolute w-48 lg:w-60 -left-8 mt-60 hidden md:block"
          src="/images/eight-ball.svg"
          alt="Eight ball"
        />
        <div>
          <PhraseePrimaryLogo
            className="text-phraseeOrange mb-10"
            width={220}
            height={60}
          />

          <GlobalErrorContent onHomeClick={resetErrorBoundary} />
        </div>
      </div>

      <AuthFooter showBookDemo={false} />
    </div>
  )
}

export default Error
